module.exports = __webpack_public_path__ + "img/video_icon09.1c299ba8.png";